// extracted by mini-css-extract-plugin
export default {"logicSettingContainer":"logicSetting_logicSettingContainer__bEPyi","divider":"logicSetting_divider__l7RWR"};